import { defineComponent, createElementBlock, openBlock, normalizeClass, unref, renderSlot } from "vue";
import { cn } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tailwind-merge@3.3.0_tailwindcss@4.1.8/node_modules/tailwind-variants/dist/index.js";
import { dialogVariants } from "../../dialog/styles/index.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "AlertDialogFooter",
  props: {
    class: {}
  },
  setup(__props) {
    const props = __props, dialogClasses = dialogVariants();
    return (_ctx, _cache) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(cn)(unref(dialogClasses).footer(), props.class)),
      "data-slot": "alert-dialog-footer"
    }, [
      renderSlot(_ctx.$slots, "default")
    ], 2));
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=AlertDialogFooter.js.map
